
import Vue from 'vue';
import VueRouter, { NavigationGuard, RouterOptions } from 'vue-router';
import Home from '../views/home/Home.vue';
import { Controlador as Autenticacion } from '@view/a-login/login-controlador';
import { socket as Socket, SocketAdmin } from '@env/ext';

Vue.use( VueRouter );

import '@com/inputs';
import '@com/selectores';
import '@com/shared';
import '@com/dialogs';
import { UsuarioActual } from '@view/a-login/login-controlador';


const ifNotAuthenticated: NavigationGuard = async ( to, from, next ) =>
{
    await Autenticacion.Iniciar();
    if ( !await Autenticacion.Validar() )
    {
        next();
    }
    else
    {
        next( '/' );
    }

};


const ifExpedicion: NavigationGuard = async ( to, from, next ) =>
{
    await Autenticacion.Iniciar();
    await Autenticacion.Comprobar( 'expedicion' );
    await Autenticacion.Autenticar( '4524' );
    next();
}

const ifAuthenticated: NavigationGuard = async ( to, from, next ) =>
{
    await Autenticacion.Iniciar();
    if ( await Autenticacion.Validar() )
    {
        if ( !Socket.connected || !SocketAdmin.Autenticado )
            await SocketAdmin.Autenticar();
        
        if ( to.fullPath.includes( 'estadisticas' ) && UsuarioActual.Grupo != 'administrador' )
            next( '/inicio' );
        else if ( to.fullPath.includes( 'control/bultos' ) && UsuarioActual.Grupo != 'expedicion' )
            next( '/inicio' );
        else
            next();
    }
    else
    {
        Autenticacion.Redireccionar = to.fullPath;
        next( '/login' );
    }
};

const routes: RouterOptions = {
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/a', component: () => import( '@env/shared/template/SinMenu.vue' ),
            children: [

                //{ path: '/pedidos', component: () => import( '@view/pedidos2/pedidos.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/pedidos2/:id', component: () => import( '@view/pedido/pedido.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/pedidos/:id', component: () => import( '@view/pedido2/pedido.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/pedidos/editar/nuevo', component: () => import( '@view/pedido-cargar2/pedido-cargar.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/pedidos/editar2/:id', component: () => import( '@view/pedido-cargar/pedido-cargar.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/pedidos/editar/:id', component: () => import( '@view/pedido-cargar2/pedido-cargar.vue' ), beforeEnter: ifAuthenticated },


                //{ path: '/pagos', component: () => import( '@view/pagos/pagos.vue' ), beforeEnter: ifAuthenticated },

                //{ path: '/publicaciones', component: () => import( '@view/publicaciones/publicaciones.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/publicaciones/:id', component: () => import( '@view/publicacion/publicacion.vue' ), beforeEnter: ifAuthenticated },

                //{ path: '/preguntas2', component: () => import( '@view/preguntas2/preguntas.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/chat', component: () => import( '@view/chat/chat.vue' ), beforeEnter: ifAuthenticated },

                //{ path: '/cursos', component: () => import( '@view/cursos/cursos.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/cursos/editar/:id', component: () => import( '@view/curso-editar-crear/curso.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/cursos/detalles/:id', component: () => import( '@view/curso-detalles/curso.vue' ), beforeEnter: ifAuthenticated },

            ]
        },
        {
            path: '/', component: () => import( '@env/shared/template/SinMenu.vue' ),
            children: [

                { path: '/', component: () => import( '@view/a-inicio/inicio.vue' ), beforeEnter: ifAuthenticated },
                { path: '/inicio', component: () => import( '@view/a-inicio/inicio.vue' ), beforeEnter: ifAuthenticated },

                { path: '/pedidos', component: () => import( '@view/a-pedidos-ml/pedidos.vue' ), beforeEnter: ifAuthenticated },
                { path: '/orders/calls', component: () => import( '@view/a-orders-call/pedidos.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pedidos/nuevo/plataformas', component: () => import( '@view/a-pedido-cargar-plataformas/pedido.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pedidos/nuevo/:tipo', component: () => import( '@view/a-pedido-cargar/pedido.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pedidos/plataformas/continuar', component: () => import( '@view/a-pedido-cargar-plataformas/pedido.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pedidos/plataformas/:id', component: () => import( '@view/a-pedido-cargar-plataformas/pedido.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pedidos/importar/excel', component: () => import( '@view/a-pedidos-importar-excel/publicaciones.vue' ), beforeEnter: ifAuthenticated },

                { path: '/pedidos/editar/:id', component: () => import( '@view/a-pedido-cargar/pedido.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pedido/:id', component: () => import( '@view/a-pedido/pedidos.vue' ), beforeEnter: ifAuthenticated },

                //{ path: '/pedidos/importar/2', component: () => import( '@view/pedido-cargar/pedido-cargar.vue' ), beforeEnter: ifAuthenticated },

                { path: '/catalogo', component: () => import( '@view/a-catalogo/catalogo.vue' ), beforeEnter: ifAuthenticated },
                { path: '/ingresos', component: () => import( '@view/a-pagos/pagos.vue' ), beforeEnter: ifAuthenticated },

                { path: '/caja', component: () => import( '@view/a-caja/caja.vue' ), beforeEnter: ifAuthenticated },

                { path: '/estadistica/reputacion', component: () => import( '@view/a-estadisticas-reputacion/estadisticas.vue' ), beforeEnter: ifAuthenticated },
                { path: '/estadistica/diaria', component: () => import( '@view/a-estadisticas-diaria/estadisticas.vue' ), beforeEnter: ifAuthenticated },
                { path: '/estadisticas', component: () => import( '@view/a-estadisticas/estadisticas.vue' ), beforeEnter: ifAuthenticated },
                { path: '/comunicacion', component: () => import( '@view/a-preguntas/estadisticas.vue' ), beforeEnter: ifAuthenticated },
                { path: '/preguntas', component: () => import( '@view/a-preguntas/estadisticas.vue' ), beforeEnter: ifAuthenticated },
                { path: '/preguntas/landscape', component: () => import( '@view/a-preguntas-pc/publicaciones.vue' ), beforeEnter: ifAuthenticated },
                { path: '/pantalla', beforeEnter: () => router.push( '/estadisticas' ) },

                { path: '/productos', component: () => import( '@view/a-articulos/articulos.vue' ), beforeEnter: ifAuthenticated },
                { path: '/articulos/imagenes/masivo', component: () => import( '@view/a-articulos-carga-imagenes/articulo.vue' ), beforeEnter: ifAuthenticated },
                { path: '/articulo/:id', component: () => import( '@view/a-articulo/articulo.vue' ), beforeEnter: ifAuthenticated },

                { path: '/intex/publicaciones', component: () => import( '@view/a-publicaciones-intex/publicaciones.vue' ), beforeEnter: ifAuthenticated },

                { path: '/mercadolibre/publicaciones', component: () => import( '@view/a-publicaciones-ml/publicaciones.vue' ), beforeEnter: ifAuthenticated },
                { path: '/mercadolibre/publicaciones/precios', component: () => import( '@view/a-publicaciones-precios-ml/publicaciones.vue' ), beforeEnter: ifAuthenticated },

                { path: '/mercadolibre/publicacion/:id', component: () => import( '@view/a-publicacion-ml/publicacion.vue' ), beforeEnter: ifAuthenticated },

                { path: '/tablas', component: () => import( '@view/a-web-categorias/categorias.vue' ), beforeEnter: ifAuthenticated },
                { path: '/web/administracion', component: () => import( '@view/a-web-administracion/administracion.vue' ), beforeEnter: ifAuthenticated },

                { path: '/clientes', component: () => import( '@view/a-inicio/inicio.vue' ), beforeEnter: ifAuthenticated },
                { path: '/padronesiibb', component: () => import( '@view/a-padrones-iibb/padrones.vue' ), beforeEnter: ifAuthenticated },

                { path: '/tablas/clientes', component: () => import( '@view/a-inicio/inicio.vue' ), beforeEnter: ifAuthenticated },
                { path: '/control/salida/expedicion', component: () => import( '@view/a-inicio/inicio.vue' ), beforeEnter: ifAuthenticated },
                { path: '/control/salida/mostrador', component: () => import( '@view/a-pedidos-entrega/pedidos.vue' ), beforeEnter: ifAuthenticated },
                { path: '/despachos/expedicion', component: () => import( '@view/a-inicio/inicio.vue' ), beforeEnter: ifAuthenticated },
                { path: '/despachos/mostrador', component: () => import( '@view/a-pedidos-entrega/pedidos.vue' ), beforeEnter: ifAuthenticated },

                { path: '/cursos', component: () => import( '@view/a-cursos/cursos.vue' ), beforeEnter: ifAuthenticated },

                { path: '/chat', component: () => import( '@view/a-chat-2/chat.vue' ), beforeEnter: ifAuthenticated },
                { path: '/mercadolibre/mensajes/automaticos', component: () => import( '@view/a-chat-ml-mensajes-automaticos/mensajes.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/chat', component: () => import( '@view/a-chat/chat.vue' ), beforeEnter: ifAuthenticated },
                { path: '/configuracion', component: () => import( '@view/a-configuracion/configuracion.vue' ), beforeEnter: ifAuthenticated },
                { path: '/ayuda', component: () => import( '@view/a-ayuda/ayuda.vue' ), beforeEnter: ifAuthenticated },

                { path: '/control/bultos', component: () => import( '@view/a-control-bultos/control.vue' ), beforeEnter: ifExpedicion},





                //{ path: '/turnero', component: () => import( '@view/turnero-ingreso/turnero.vue' ) },
                //{ path: '/turnero/puestos', component: () => import( '@view/turnero-puesto/turnero.vue' ) },

                //{ path: '/control/salida/general', component: () => import( '@view/control-pedidos-mod/pedidos.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/pedido/editar', component: () => import( '@view/ventas-pedidos-mod/pedidos.vue' ), beforeEnter: ifAuthenticated },

                //{ path: '/proveedores', component: () => import( '@view/proveedores/proveedores.vue' ) },
                { path: '/login2', component: () => import( '@view/a-login/login.vue' ) },
                { path: '/login', component: () => import( '@view/a-login/login.vue' ), beforeEnter: ifNotAuthenticated },
                { path: '/login/:id', component: () => import( '@view/a-login/login.vue' ), beforeEnter: ifNotAuthenticated },
                { path: '/recuperar/:id', component: () => import( '@view/a-login/login.vue' ), beforeEnter: ifNotAuthenticated },
                //{ path: '/dtx/cursos/tomar', component: () => import( '@view/curso-tomar/curso.vue' ), beforeEnter: ifAuthenticated },
                //{ path: '/dtx/cursos/tomar/:id', component: () => import( '@view/curso-tomar/curso.vue' ), beforeEnter: ifAuthenticated },

            ]
        },

        //{ path: '/pantalla', component: () => import( '@view/pantalla/pantalla.vue' ) },
        //{ path: '/login', component: () => import( '@env/shared/login/login-ingreso.vue' ), beforeEnter: ifNotAuthenticated },
        //{ path: '/nuevo', component: () => import( '@env/shared/login/login-nuevo.vue' ), beforeEnter: ifNotAuthenticated },
        //{ path: '/recuperar', component: () => import( '@env/shared/login/login-recuperar.vue' ), beforeEnter: ifNotAuthenticated },
        //{ path: '/recuperar/:id?', component: () => import( '@env/shared/login/login-recuperar.vue' ), beforeEnter: ifNotAuthenticated },


    ]
};


const router = new VueRouter( routes );

export default router;
